"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var vega_embed_1 = __importDefault(require("vega-embed"));

var render_utils_1 = require("./render_utils");

function scatterplot(container, data) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _values, _series, values, drawArea, options, embedOpts, xDomain, yDomain, spec;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _values = data.values;
            _series = data.series == null ? [] : data.series;
            _values = Array.isArray(_values[0]) ? _values : [_values];
            values = [];

            _values.forEach(function (seriesData, i) {
              var seriesName = _series[i] != null ? _series[i] : "Series ".concat(i + 1);
              var seriesVals = seriesData.map(function (v) {
                return Object.assign({}, v, {
                  series: seriesName
                });
              });
              values.push.apply(values, _toConsumableArray(seriesVals));
            });

            drawArea = render_utils_1.getDrawArea(container);
            options = Object.assign({}, defaultOpts, opts);
            embedOpts = {
              actions: false,
              mode: 'vega-lite',
              defaultStyle: false
            };

            xDomain = function xDomain() {
              if (options.zoomToFit) {
                return {
                  'zero': false
                };
              } else if (options.xAxisDomain != null) {
                return {
                  'domain': options.xAxisDomain
                };
              }

              return undefined;
            };

            yDomain = function yDomain() {
              if (options.zoomToFit) {
                return {
                  'zero': false
                };
              } else if (options.yAxisDomain != null) {
                return {
                  'domain': options.yAxisDomain
                };
              }

              return undefined;
            };

            spec = {
              'width': options.width || drawArea.clientWidth,
              'height': options.height || drawArea.clientHeight,
              'padding': 0,
              'autosize': {
                'type': 'fit',
                'contains': 'padding',
                'resize': true
              },
              'config': {
                'axis': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                },
                'text': {
                  'fontSize': options.fontSize
                },
                'legend': {
                  'labelFontSize': options.fontSize,
                  'titleFontSize': options.fontSize
                }
              },
              'data': {
                'values': values
              },
              'mark': {
                'type': 'point',
                'clip': true,
                'tooltip': {
                  'content': 'data'
                }
              },
              'encoding': {
                'x': {
                  'field': 'x',
                  'type': options.xType,
                  'title': options.xLabel,
                  'scale': xDomain()
                },
                'y': {
                  'field': 'y',
                  'type': options.yType,
                  'title': options.yLabel,
                  'scale': yDomain()
                },
                'color': {
                  'field': 'series',
                  'type': 'nominal'
                },
                'shape': {
                  'field': 'series',
                  'type': 'nominal'
                }
              }
            };
            _context.next = 13;
            return vega_embed_1.default(drawArea, spec, embedOpts);

          case 13:
            return _context.abrupt("return", Promise.resolve());

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.scatterplot = scatterplot;
var defaultOpts = {
  xLabel: 'x',
  yLabel: 'y',
  xType: 'quantitative',
  yType: 'quantitative',
  zoomToFit: false,
  fontSize: 11
};